import { isSchoolFeatureEnabled } from './schoolFeatures';

export function shouldShowBranchLabels(user, activeBranchId) {
  return isSchoolFeatureEnabled(user, 'branches') && activeBranchId == null;
}

export function getBranchName(row) {
  const name = row?.branch_name;
  if (name === undefined || name === null) return null;
  const trimmed = String(name).trim();
  return trimmed || null;
}

export function formatWithBranchLabel(name, branchName, show) {
  if (!show || !branchName) return name ?? '';
  const base = name ?? '';
  return base ? `${base} (${branchName})` : branchName;
}
